import { motion } from "../../lib/motionSafe"; // polku suhteessa komponenttiin

import React from "react";

/** Light: konfetti + underline. Dark: hover-hehku tekstin taakse + underline. */
export default function ConfettiLinkLabel({ children, isActive }) {
  const colors = ["#FF2D95", "#31FFD9", "#00B8FF", "#FFF455"];
  const dots = Array.from({ length: 10 });

  return (
    <motion.span
      className="relative inline-flex items-center z-0 group"
      initial="rest"
      whileHover="explode"
      animate={isActive ? "active" : "rest"}
    >
      {/* DARK-ONLY glow (ei negatiivista z-indexiä) */}
      <motion.span
        className="
          hidden dark:block
          absolute inset-[-24x] z-0 rounded-xl
          blur-xl opacity-0
          will-change-transform will-change-opacity
        "
        style={{
          // Radiaalinen neon-hehku: purple -> aqua -> transparent
          background:
            "radial-gradient(60% 60% at 50% 50%, rgba(122,0,255,0.28) 0%, rgba(49,255,217,0.25) 40%, rgba(0,0,0,0) 70%)",
          // Halutessasi voimakkaampi sekoitus:
          mixBlendMode: "screen",
        }}
        variants={{
          rest:    { opacity: 0,   scale: 0.96 },
          explode: { opacity: 0.55, scale: 1.05 },
          active:  { opacity: 0.32, scale: 1.0 },
        }}
        transition={{ duration: 0.22, ease: "easeOut" }}
      />

      {/* Teksti (aina hehkun päällä) */}
      <span className="relative z-10">{children}</span>

      {/* Alaviiva – kasvaa hoverissa, täysi leveys active-tilassa */}
      <motion.span
        className="absolute left-0 -bottom-1 h-0.5 bg-current origin-left z-10"
        variants={{
          rest:    { width: isActive ? "100%" : "0%" },
          explode: { width: "100%" },
          active:  { width: "100%" },
        }}
        transition={{ duration: 0.15, ease: "easeOut" }}
      />

      {/* Konfetti – vain LIGHT-tilassa */}
      <span className="pointer-events-none absolute inset-0 z-20 dark:hidden">
        {dots.map((_, i) => {
          const angle = (i / dots.length) * Math.PI * 2;
          const radius = 18 + (i % 3) * 6;
          const x = Math.cos(angle) * radius;
          const y = Math.sin(angle) * -radius;

          return (
            <motion.span
              key={i}
              className="absolute left-1/2 top-1/2 w-1.5 h-1.5 rounded-full"
              style={{
                translateX: "-50%",
                translateY: "-50%",
                backgroundColor: colors[i % colors.length],
                filter: "drop-shadow(0 0 6px rgba(255,255,255,0.35))",
              }}
              variants={{
                rest:    { opacity: 0, x: 0, y: 0, scale: 0.6, rotate: 0 },
                explode: { opacity: [0, 1, 0], x, y, scale: 1, rotate: 180 },
                active:  { opacity: 0, x: 0, y: 0, scale: 0.6, rotate: 0 },
              }}
              transition={{ duration: 0.55, ease: "easeOut", delay: 0.015 * (i % 5) }}
            />
          );
        })}
      </span>
    </motion.span>
  );
}
